<div class="container" *ngIf="patient">

    <mc-patient-header [patient]="patient"></mc-patient-header>
    <mc-appointment-form (canceled)="onFormCanceled()" (saved)="onFormSaved($event)"></mc-appointment-form>

    <br />
    <br />

</div>
